import { render, staticRenderFns } from "./BookAddForm.vue?vue&type=template&id=25ba3990&"
import script from "./BookAddForm.vue?vue&type=script&lang=js&"
export * from "./BookAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports